import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=297a338c&scoped=true&"
import script from "./BlogPost.vue?vue&type=script&lang=js&"
export * from "./BlogPost.vue?vue&type=script&lang=js&"
import style1 from "./BlogPost.vue?vue&type=style&index=1&id=297a338c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297a338c",
  null
  
)

export default component.exports